"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendRequest = void 0;
var SendRequest = /** @class */ (function () {
    function SendRequest() {
    }
    return SendRequest;
}());
exports.SendRequest = SendRequest;
;
//# sourceMappingURL=send.request.js.map